(function () {
  'use strict';

  var widgetSelector = '.bootstrap-ica';
  var listSelector = "[class^='fbt_list_'], [class*=' fbt_list_']";
  var imageBoxSelector = "[class^='fbt_imgbox_'], [class*=' fbt_imgbox_']";

  function isFbtWidget(element) {
    return Boolean(
      element.querySelector(
        "input.selectedproduct, [class^='fbt_header_'], [class*=' fbt_header_'], " + listSelector
      )
    );
  }

  function getDataImageUrl(element) {
    if (!element || !element.dataset) return '';
    return element.dataset.img || element.dataset.image || element.dataset.imageUrl || element.dataset.src || '';
  }

  function getBackgroundImageUrl(element) {
    if (!element) return '';

    var directImage = element.currentSrc || element.src || getDataImageUrl(element);
    if (directImage) return directImage;

    var nestedImage = element.querySelector && element.querySelector('img[src], img[data-src]');
    if (nestedImage) {
      directImage = nestedImage.currentSrc || nestedImage.src || getDataImageUrl(nestedImage);
      if (directImage) return directImage;
    }

    var backgroundImage = element.style && element.style.backgroundImage;
    if (!backgroundImage || backgroundImage === 'none') {
      backgroundImage = window.getComputedStyle(element).backgroundImage;
    }

    var match = backgroundImage && backgroundImage.match(/url\((['"]?)(.*?)\1\)/);
    return match ? match[2] : '';
  }

  function getLegacyImageUrls(widget) {
    var urls = [];
    var imageLists = widget.querySelectorAll("[class^='fbt_imglist_'], [class*=' fbt_imglist_']");

    Array.prototype.forEach.call(imageLists, function (imageList) {
      var candidates = imageList.querySelectorAll('.fp-img');
      if (!candidates.length) candidates = imageList.querySelectorAll('img[src], img[data-src]');

      Array.prototype.forEach.call(candidates, function (candidate) {
        var imageUrl = getBackgroundImageUrl(candidate);
        if (imageUrl) urls.push(imageUrl);
      });
    });

    return urls;
  }

  function getImageUrl(input, select, fallbackImageUrl) {
    var option = select && select.options && select.options[select.selectedIndex];
    return getDataImageUrl(option) || getDataImageUrl(select) || getDataImageUrl(input) || fallbackImageUrl || '';
  }

  function setCardImage(card, input, select, fallbackImageUrl) {
    var image = card.querySelector('.tallah-fbt-card__image');
    var imageUrl = getImageUrl(input, select, fallbackImageUrl);

    if (!image) {
      image = document.createElement('span');
      image.className = 'tallah-fbt-card__image';
      image.setAttribute('aria-hidden', 'true');
      var anchor = card.querySelector('.fbtbox > a, .fbtbox .fbt-title a');
      var insertionPoint = anchor && anchor.parentNode ? anchor.parentNode : card.querySelector('.fbtbox');
      if (insertionPoint) {
        insertionPoint.insertBefore(image, insertionPoint.firstChild);
      }
    }

    if (image) {
      if (imageUrl) {
        image.style.setProperty(
          'background-image',
          'url("' + imageUrl.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")',
          'important'
        );
      } else {
        image.style.removeProperty('background-image');
      }
    }
  }

  function decorateCard(card, fallbackImageUrl) {
    var checkbox = card.querySelector('input.selectedproduct');
    var select = card.querySelector("[class^='variant_'], [class*=' variant_']");

    card.classList.add('tallah-fbt-card');
    card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
    setCardImage(card, checkbox, select, fallbackImageUrl);

    if (checkbox && !checkbox.dataset.tallahFbtBound) {
      checkbox.dataset.tallahFbtBound = 'true';
      checkbox.addEventListener('change', function () {
        card.classList.toggle('is-selected', checkbox.checked);
      });
    }

    if (select && !select.dataset.tallahFbtBound) {
      select.dataset.tallahFbtBound = 'true';
      select.addEventListener('change', function () {
        setCardImage(card, checkbox, select, fallbackImageUrl);
      });
    }
  }

  function createNote() {
    var note = document.createElement('div');
    var check = document.createElement('span');
    var copy = document.createElement('p');

    note.className = 'tallah-fbt__note';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    copy.textContent = 'Complete your routine with products that pair perfectly with this item.';
    note.appendChild(check);
    note.appendChild(copy);
    return note;
  }

  function layoutWidget(widget) {
    var list = widget.querySelector(listSelector);
    if (!list) return;
    var legacyImageUrls = getLegacyImageUrls(widget);

    Array.prototype.forEach.call(list.children, function (card, index) {
      if (card.tagName === 'LI') decorateCard(card, legacyImageUrls[index] || '');
    });

    var panel = widget.querySelector('.tallah-fbt__panel');
    var footer = widget.querySelector('.fbt-footer');

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'tallah-fbt__panel';
      list.parentNode.insertBefore(panel, list);
      panel.appendChild(list);
    }

    if (footer && footer.parentNode !== panel) {
      panel.appendChild(footer);
    }

    var note = panel.querySelector('.tallah-fbt__note');
    if (!note) {
      note = createNote();
      if (footer) {
        panel.insertBefore(note, footer);
      } else {
        panel.appendChild(note);
      }
    }

    Array.prototype.forEach.call(widget.querySelectorAll(imageBoxSelector), function (imageBox) {
      if (!imageBox.querySelector('.fbt-footer')) {
        imageBox.classList.add('tallah-fbt__legacy-media');
      }
    });
  }

  function enhanceWidgets() {
    Array.prototype.forEach.call(document.querySelectorAll('.tallah-fbt:not(.bootstrap-ica)'), function (wrapper) {
      wrapper.classList.remove('tallah-fbt');
      delete wrapper.dataset.tallahFbtReady;
    });

    Array.prototype.forEach.call(document.querySelectorAll(widgetSelector), function (widget) {
      if (!isFbtWidget(widget)) return;
      widget.classList.add('tallah-fbt');
      widget.dataset.tallahFbtReady = 'true';
      layoutWidget(widget);
    });
  }

  var queued = false;
  function queueEnhancement() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      enhanceWidgets();
    });
  }

  document.addEventListener('DOMContentLoaded', queueEnhancement);
  window.addEventListener('load', queueEnhancement);
  new MutationObserver(queueEnhancement).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
